module.exports = __webpack_public_path__ + "static/media/samus_0.85ea2150.png";